import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AssistanceBasic } from 'src/app/models/helpbutton-models/helpbutton-assistance-basic.model';
import { DateUnixTransformerPipe } from 'src/app/pipes/date-unix-transformer-pipe/date-unix-transformer.pipe';
import { TimeMillisToMinutesAndSecondsPipe } from 'src/app/pipes/time-millis-to-minutes-and-seconds/time-millis-to-minutes-and-seconds.pipe';

@Component({
  selector: 'app-helpbutton-report-info-card',
  templateUrl: './helpbutton-report-info-card.component.html',
  styleUrls: ['./helpbutton-report-info-card.component.scss']
})
export class HelpbuttonReportInfoCardComponent implements OnInit, OnChanges {

  @Input() assistance: AssistanceBasic;
  editingLocked: boolean;
  openPlaceholder: string;
  closePlaceholder: string;
  insituPlaceholder: string;
  staffPlaceholder: string;
  staffcommentsPlaceholder: string;
  customerPlaceholder: string;
  customercommentsPlaceholder: string;
  storePlaceholder: string;
  departmentPlaceholder: string;
  videocallPlaceholder: string;
  timeacceptancePlaceholder: string;
  totalassistancePlaceholder: string;
  basicDataForm = new FormGroup({
    open: new FormControl({ value: '', disabled: true }),
    close: new FormControl({ value: '', disabled: true }),
    insitu: new FormControl({ value: '', disabled: true }),
    staff: new FormControl({ value: '', disabled: true }),
    staffcomments: new FormControl({ value: '', disabled: true }),
    customer: new FormControl({ value: '', disabled: true }),
    customercomments: new FormControl({ value: '', disabled: true }),
    store: new FormControl({ value: '', disabled: true }),
    department: new FormControl({ value: '', disabled: true }),
    timeacceptance: new FormControl({ value: '', disabled: true }),
    type: new FormControl({ value: '', disabled: true }),
    totalassistance: new FormControl({ value: '', disabled: true }),
  });
  constructor(private dateUnixTransformerPipe: DateUnixTransformerPipe,
              private timeMillisToMinutesAndSecondsPipe: TimeMillisToMinutesAndSecondsPipe) {
    this.editingLocked = true;
    this.openPlaceholder = 'helpbutton-page.open';
    this.closePlaceholder = 'helpbutton-page.close';
    this.insituPlaceholder = 'helpbutton-page.insitu';
    this.staffPlaceholder = 'helpbutton-page.staff';
    this.staffcommentsPlaceholder = 'helpbutton-page.staff comments';
    this.customerPlaceholder = 'helpbutton-page.customer';
    this.customercommentsPlaceholder = 'helpbutton-page.customer comments';
    this.storePlaceholder = 'helpbutton-page.store';
    this.departmentPlaceholder = 'helpbutton-page.department';
    this.totalassistancePlaceholder = 'helpbutton-page.total assistance';
    this.timeacceptancePlaceholder = 'helpbutton-page.time acceptance';
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.assistance) {
      this.basicDataForm.patchValue({
        open: this.assistance.CreationDate ? this.dateUnixTransformerPipe.transform(this.assistance.CreationDate) : '-',
        close: this.assistance.EndDate ? this.dateUnixTransformerPipe.transform(this.assistance.EndDate) : '-',
        insitu: this.assistance.InSituDate ? this.dateUnixTransformerPipe.transform(this.assistance.InSituDate) : '-',
        staff: this.assistance.AssistanceEmployeeName ? this.assistance.AssistanceEmployeeName : '-',
        staffcomments: this.assistance.StaffComments ? this.assistance.StaffComments : '-',
        customer: this.assistance.CustomerName ? this.assistance.CustomerName : '-',
        customercomments: this.assistance.CustomerComments ? this.assistance.CustomerComments : '-',
        totalassistance: this.assistance.TotalAssistanceTime ? this.timeMillisToMinutesAndSecondsPipe.transform(this.assistance.TotalAssistanceTime) : '-',
        timeacceptance: this.assistance.TimeUntilAcceptance ? this.timeMillisToMinutesAndSecondsPipe.transform(this.assistance.TimeUntilAcceptance) : '-',
        store: this.assistance.CustomerName ? this.assistance['sectionDto']['centerDto']['centerName'] : '-',
        department: this.assistance.CustomerName ? this.assistance['sectionDto']['sectionName'] : '-',
        type: this.assistance.AssistanceType === 'VIDEO' ? 'Videocall' : 'Assistance'
      });
    }
  }

  public getStatus(status) {
    switch (status) {
      case 'OPEN':
        return 'WAITING';
      case 'IN_ASSISTANCE':
        return 'ATTENDING';
      case 'CLOSED':
        return 'CLOSED';
      case 'CANCELLED':
        return 'ABORTED';
      case 'CANCELLED_AUTOMATICALLY':
        return 'IGNORED';
    }
  }

  public getColor(status) {
    switch (status) {
      case 'OPEN':
        return 'gray';
      case 'IN_ASSISTANCE':
        return 'blue';
      case 'CLOSED':
        return 'green';
      case 'CANCELLED':
        return 'orange';
      case 'CANCELLED_AUTOMATICALLY':
        return 'red';
    }
  }

}
